import { render } from "./VideoCollections.vue?vue&type=template&id=53eed5dc"
import script from "./VideoCollections.vue?vue&type=script&lang=js"
export * from "./VideoCollections.vue?vue&type=script&lang=js"

import "./VideoCollections.vue?vue&type=style&index=0&id=53eed5dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__